import defaultSettings from '@/settings'

const title = defaultSettings.title || 'Energy Storage Monitoring'

export default function getPageTitle(pageTitle) {
  if (pageTitle) {
    return `${pageTitle} - ${title}`
  }
  return `${title}`
}
